/* Builder A · WF-08 shared bits. No new CSS — the paused mark (⊘) uses the
   existing .pill .pill-done classes exactly as Accueil.tsx uses .pill-ok,
   because Pill’s tone marks are fixed and the frame draws ⊘, not ✓.

   Batch 12: the platform mark moved to `@/ui` as `PlatformMark` — the same
   drawing, one copy for « Liens d’avis », the campaign stepper and these
   screens. The day counsel answers §10.1, the real logo lands there and
   nowhere else. `Marque` is retired; import `PlatformMark` from `@/ui`. */
import { Link } from 'react-router-dom'
import { Pill, Skeleton, type PillTone } from '@/ui'
import type { DestTone } from './api'

export const Retour = () => (
  <p className="f-help" style={{ margin: 0 }}><Link to="/destinations">‹ Liens d’avis — détail</Link></p>
)

const TONE: Record<Exclude<DestTone, 'paused'>, PillTone> = { ok: 'ok', warn: 'warn', crit: 'crit' }

export function Etat({ tone, label }: { tone: DestTone; label: string }) {
  if (tone === 'paused') return <span className="pill pill-done">⊘ {label}</span>
  return <Pill tone={TONE[tone]}>{label}</Pill>
}


/** DS-02 · the seven technical checks, in the merchant’s words. A known
 *  platform passes all seven; a custom link is only ever asked the two that
 *  can be answered about a page nobody else publishes (batch-9 addendum). */
export const CONTROLES = [
  'HTTPS', 'hôte reconnu', 'structure d’URL', 'redirections',
  'correspondance fiche ↔ établissement', 'aperçu client', 'test d’ouverture',
]
export const CONTROLES_LIEN = ['le lien répond', 'la page est bien la vôtre']

/** The candour line that must travel with any pass — a technical check is
 *  never a compliance verdict (§18). */
export const CANDEUR =
  'La validation technique confirme que le lien s’ouvre correctement — jamais qu’un avis a été déposé, ni que la méthode est approuvée par la plateforme.'

export const Chargement = () => (
  <div style={{ display: 'grid', gap: 10, maxWidth: 720 }}>
    <Skeleton width="42%" /><Skeleton /><Skeleton width="65%" />
  </div>
)
